import { useCallback } from 'react'

import { useNotification } from '@/hooks'
import { roadSegmentsUtils } from '@/utils'

import { useDeleteRoadSegmentModal } from '../../../../modals/DeleteRoadSegmentModal'

export function useActions(segments: uui.domain.client.rm.SegmentException[]) {
  const toast = useNotification()
  const { show: showDeleteRoadSegmentModal } = useDeleteRoadSegmentModal()

  const onExport = useCallback(async () => {
    try {
      roadSegmentsUtils.exportRoadSegmentsToKML(segments)
    } catch (e) {
      toast.error(e.message)
    }
  }, [toast, segments])

  const onDelete = useCallback(() => {
    showDeleteRoadSegmentModal()
  }, [showDeleteRoadSegmentModal])

  return {
    onExport,
    onDelete,
  }
}
